"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSendNotificationsToggle = exports.SendNotificationsToggle = void 0;
var _react = _interopRequireWildcard(require("react"));
var _components = require("../../../components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var TOGGLE_ID = 'send-notifications-toggle';
var SendNotificationsToggle = function SendNotificationsToggle(_ref) {
  var checked = _ref.checked,
    onChange = _ref.onChange;
  return (
    /*#__PURE__*/
    // Instead of the toggle being initially checked with the label "Send notifications",
    // after consulting with James it would be better UX to have the toggle initially unchecked
    _react.default.createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/_react.default.createElement(_components.Toggle, {
      id: TOGGLE_ID,
      checked: checked,
      onChange: onChange
    }), /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: TOGGLE_ID,
      className: "tw-body-regular ml-[12px]"
    }, "Don\u2019t send notifications"))
  );
};
exports.SendNotificationsToggle = SendNotificationsToggle;
var useSendNotificationsToggle = function useSendNotificationsToggle() {
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    sendNotifications = _useState2[0],
    setSendNotifications = _useState2[1];
  return {
    toggleProps: {
      checked: !sendNotifications,
      onChange: function onChange(e) {
        return setSendNotifications(!e.target.checked);
      }
    },
    sendNotifications: sendNotifications
  };
};
exports.useSendNotificationsToggle = useSendNotificationsToggle;